var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Page",class:{ 'Page--landscape': _vm.landscape, 'Page--marginless': _vm.marginless }},[_c('div',{staticClass:"Print w-100 h-100 d-flex flex-column"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }